var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-sm m-r show-balance-modal",attrs:{"disabled":_vm.disabled},on:{"click":_vm.showModal}},[_vm._v(_vm._s(_vm.__('generate_balance')))])}
var staticRenderFns = []

export { render, staticRenderFns }